import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COLLECTIONS_TAG, CollectionState } from './collections.reducer';

const selectCollectionState = createFeatureSelector<CollectionState>(COLLECTIONS_TAG);

export const selectCollectionsData = createSelector(selectCollectionState, (state: CollectionState) => state.data);
export const selectCollectionsPages = createSelector(selectCollectionState, (state: CollectionState) => state.pages);
export const selectCollectionsSearch = createSelector(selectCollectionState, (state: CollectionState) => state.gridSearch);
export const selectFetchCollectionStatus = createSelector(selectCollectionState, (state: CollectionState) => state.fetchCollectionStatus);
